var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFbIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_491_2603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 20.0008C40 8.95507 31.0457 0.000778198 20 0.000778198C8.9543 0.000778198 0 8.95507 0 20.0008C0 29.9834 7.31371 38.2574 16.875 39.7578V25.782H11.7969V20.0008H16.875V15.5945C16.875 10.582 19.8609 7.81328 24.4293 7.81328C26.6175 7.81328 28.9062 8.2039 28.9062 8.2039V13.1258H26.3843C23.8998 13.1258 23.125 14.6675 23.125 16.2491V20.0008H28.6719L27.7852 25.782H23.125V39.7578C32.6863 38.2574 40 29.9834 40 20.0008Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7852 25.7812L28.6719 20H23.125V16.2483C23.125 14.6667 23.8998 13.125 26.3843 13.125H28.9063V8.20312C28.9063 8.20312 26.6175 7.8125 24.4293 7.8125C19.8609 7.8125 16.875 10.5812 16.875 15.5938V20H11.7969V25.7812H16.875V39.757C17.8932 39.9168 18.9369 40 20 40C21.0631 40 22.1068 39.9168 23.125 39.757V25.7812H27.7852Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_491_2603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIco);
export default __webpack_public_path__ + "static/media/fb_ico.9d3bd0bf299ca902bd5c3063339b7d0d.svg";
export { ForwardRef as ReactComponent };